// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"936":"2af74407","2454":"2af74407","4461":"2af74407","5168":"2af74407","5567":"2af74407","6621":"2af74407","7285":"2af74407","9407":"2af74407","9519":"2af74407","9928":"2af74407"}[chunkId] + ".chunk.css";
};